import { DatePicker } from 'antd';
import classnames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { ReactComponent as BarChartIcon } from 'assets/bosta-icons/bar-chart-1.svg';

import './PerformanceDatePicker.less';

const PerformanceDatePicker = ({
  dateValue,
  setDateValue,
  businessData,
  isLoading,
  ...props
}) => {
  const intl = useIntl();
  const datePickerRef = useRef();
  const [open, setOpen] = useState(false);
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false);

  useEffect(() => {
    if (!businessData?._id || isLoading || dateValue || hasOpenedOnce) {
      return;
    }

    const timer = setTimeout(() => {
      setOpen(true);
      handleFocus();
      setHasOpenedOnce(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [businessData, isLoading, dateValue, hasOpenedOnce]);

  const handleFocus = () => {
    datePickerRef.current?.focus?.();
  };

  const onChangeDate = (date) => {
    if (!date) {
      setDateValue(null);
      handleFocus();
      return;
    }
    setOpen(false);
    setDateValue(date);
  };

  return (
    <div className="br-merchant-performance-section">
      <div className="br-merchant-performance-section__title">
        <BarChartIcon />
        <span className="heading1">
          {intl.formatMessage({
            id: 'merchant_analysis.performance'
          })}
        </span>
      </div>

      <DatePicker
        ref={datePickerRef}
        open={open}
        onOpenChange={(status) => setOpen(status)}
        onChange={onChangeDate}
        picker="month"
        format={'YYYY, MMM'}
        allowClear
        className={classnames('br-merchant-performance-section__date-picker', {
          'date-selected': !!dateValue
        })}
        value={dateValue}
      />
    </div>
  );
};

export default PerformanceDatePicker;
